import { getSearchPredictions } from 'data/search-predictions';
import SearchPrediction from 'data/search-predictions';
import { SearchStrategy, SearchStrategyProps, SearchResult } from './SearchStrategy';
import { ThemeNames } from 'types/themes';

export abstract class BaseSearchStrategy implements SearchStrategy {
  /**
   * Base search method that handles common functionality across search strategies
   */
  async search(props: SearchStrategyProps): Promise<SearchResult> {
    try {
      const { queryString, siteLocation, themeName, features } = props;
      
      // Get predictions from go-search
      const goSearchPredictions = await getSearchPredictions({ 
        query: queryString.toLowerCase(), 
        country: themeName !== ThemeNames.ZOOCASA ? siteLocation : '', 
      }, features);
      
      // This is the main method that subclasses will override to provide 
      // strategy-specific behavior
      return await this.processSearchResults(goSearchPredictions, props);
    } catch (err) {
      console.error(err);
      return {
        searchPredictions: [],
        searchAgentPredictions: [],
      };
    }
  }

  /**
   * Strategy-specific method to process search results
   * Each subclass must implement this method to provide its specific search behavior
   */
  protected abstract processSearchResults(
    goSearchPredictions: SearchPrediction[],
    props: SearchStrategyProps
  ): Promise<SearchResult>;
} 